import { btnTypes } from '@r1-frontend/ui-react/components/buttons/baseButton';
import DocumentLink from '@r1-frontend/ui-react/components/buttons/documentLink';
import React from 'react';

import { Button, Container, Header, SubHeader, Text, Wrapper } from './styled';

const Ktv = ({ file }) => {
    return (
        <Wrapper>
            <Container>
                <Header>Кабельное телевидение Дом.ру</Header>
                <SubHeader>Переходите на современное ТВ</SubHeader>
                <Text>
                    Замените кабельное ТВ дома на современное и смотрите 200 каналов в HD-формате с отличным звуком.
                    Перематывайте рекламу, ставьте сериал на паузу и смотрите премьеры фильмов в онлайн-кинотеатре.
                </Text>
                <Text>
                    А еще можно управлять каналами: создавайте из них списки интересных, добавляйте новые и отключайте надоевшие.
                </Text>
                <SubHeader>Преимущества, которых нет у кабельного</SubHeader>
                <Text>
                    1. Широкий выбор тематических каналов: детские, развлекательные, новостные и  спортивные; <br/>
                    2. Возможность выходить в интернет и смотреть YouTube-видео прямо на экране телевизора;
                    <br/>
                    3. Функция управления эфиром: с помощью пульта перемотайте фильм на любимую сцену и посмотрите ее еще раз;
                    <br/>
                    4. Просмотр на разных устройствах: телефоне, компьютере или планшете.
                </Text>
                <Text>
                    Современное ТВ от Дом.ру техник настроит за один визит. А кабельное ТВ может подключить дополнительно — оно будет доступно к просмотру на втором телевизоре.
                </Text>
                <Button
                    href='/movix-new'
                    type={btnTypes.ACCENT}
                    text='Узнать о цифровом ТВ'
                />
                <SubHeader>У вас кабельное ТВ?</SubHeader>
                <Text>
                    Вам может пригодиться частотно-территориальный план каналов и кнопки на пульте.
                </Text>
                {file && <DocumentLink file={file} />}
            </Container>
        </Wrapper>
    );
};

export default Ktv;
